module.exports = __webpack_public_path__ + "img/notifications.63c3d7b9.svg";